import { render, staticRenderFns } from "./vita-upload.vue?vue&type=template&id=4034e3af&scoped=true&"
import script from "./vita-upload.vue?vue&type=script&lang=js&"
export * from "./vita-upload.vue?vue&type=script&lang=js&"
import style0 from "./vita-upload.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./vita-upload.vue?vue&type=style&index=1&id=4034e3af&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4034e3af",
  null
  
)

export default component.exports